module.exports = __webpack_public_path__ + "img/level_four_hover.9c1f2e46.png";